import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { environment } from '../../../environments/environment';
import { MenuService } from '../../services/menu/menu.service';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { MenuAppModel, MenuModel } from 'src/app/services/sso/models/menu.model';
import { CrudService } from 'src/app/services/crud/crud.service';
import { AplicacionModel } from 'src/app/services/sso/models/aplicacion.model';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.css']
})
export class AppMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('grid') grid: jqxGridComponent;

  private componentRef = null;
  public environment = environment;

  // Variables para grid y dropdownlist
  public dataSource;
  public dataAdapter;
  public menusAdapter;
  public menusArray: MenuModel[] = [];
  public menus = new Map<number, MenuModel>();
  public apps = new Map<number, AplicacionModel>();
  public menuApps = new Map<number, MenuAppModel>();
  public rows: any[] = [];

  // Preparo las columnas del grid
  public columns = [
    {
      text: 'Id', columntype: 'textbox', datafield: 'id', width: 10, hidden: true
    },
    {
      text: 'AppId', columntype: 'textbox', datafield: 'appId', width: 10, hidden: true
    },
    {
      text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'appNombre', width: 300,
      editable: false,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="margin-left: 4px;">Total: ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    {
      text: 'MenuId', columntype: 'textbox', datafield: 'menuId', width: 10, hidden: true
    },
    {
      text: 'Menú', datafield: 'menuNombre', displayfield: 'MenuNombre', columntype: 'dropdownlist', width: 280,
      createeditor: (row: number, value: any, editor: any): void => {
        editor.jqxDropDownList({
          width: '280px', height: 32, source: this.menusAdapter,
          displayMember: 'label', valueMember: 'value'
        });
      }
    },
    {
      text: 'Observaciones', columntype: 'textbox', filtertype: 'textbox', datafield: 'observ', width: 450,
      editable: false,
    }
  ];

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private menuService: MenuService,
    private crudService: CrudService) {
  }

  ngOnInit(): void {
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async ngAfterViewInit() {
    this.loader.open();
    const apps = await this.crudService.getApps();
    this.menusArray = await this.menuService.getMenus();
    const menusApp = await this.menuService.getMenusApp();
    if (apps) {
      apps.forEach(app => {
        this.apps.set(app.Id, app);
      });
    }
    if (this.menusArray) {
      this.menusArray.forEach(menu => {
        this.menus.set(menu.Id, menu);
      });
    }
    if (menusApp) {
      menusApp.forEach(ma => {
        this.menuApps.set(ma.AplicacionId, ma);
      });
    }
    if (apps) {
      apps.forEach(app => {
        let id, menuId, appId, menuNombre, appNombre, menuObserv;
        const ma = this.menuApps.get(app.Id);
        if (ma) {
          id = ma.Id;
          menuId = ma.MenuId;
          menuNombre = this.menus.get(menuId).Nombre;
          appId = ma.AplicacionId;
          appNombre = this.apps.get(appId).Nombre;
          menuObserv = this.menus.get(menuId).Observaciones;
        } else {
          id = 0;
          menuId = 1; // Menú base
          menuNombre = this.menus.get(1).Nombre;
          appId = app.Id;
          appNombre = this.apps.get(app.Id).Nombre;
          menuObserv = this.menus.get(1).Observaciones
        }
        this.rows.push({
          Id: id,
          AppId: appId,
          AppNombre: appNombre,
          MenuId: menuId,
          MenuNombre: menuNombre,
          Observ: menuObserv
        });
      });
      this.fillGrid();
    }
    this.loader.close();
  }

  // Rellena el grid
  async fillGrid() {
    this.loader.open();
    // Creo un adaptador con los datos de todos los menús para poner en el combo
    const menusSource =
    {
      datatype: 'array',
      datafields: [
        { name: 'label', type: 'string', map: 'Nombre' },
        { name: 'value', type: 'number', map: 'Id' }
      ],
      localdata: this.menusArray
    };
    this.menusAdapter = new jqx.dataAdapter(menusSource, { autoBind: true });
    try {
      if (this.rows) {
        this.dataSource = {
          datatype: 'json',
          datafields: [
            { name: 'id', type: 'number', map: 'Id' },
            { name: 'appId', type: 'number', map: 'AppId' },
            { name: 'appNombre', type: 'string', map: 'AppNombre' },
            { name: 'menuId', type: 'number', map: 'MenuId' },
            {
              name: 'MenuNombre', value: 'MenuNombre',
              values: {
                source: this.menusAdapter.records, value: 'value', name: 'label'
              }
            },
            { name: 'menuNombre', type: 'string' },
            { name: 'observ', type: 'string', map: 'Observ' }
          ],
          localdata: this.rows,
          sortcolumn: 'appNombre',
          sortdirection: 'asc'
        }
        this.dataAdapter = new jqx.dataAdapter(this.dataSource);
      }
    } catch (e) {
      console.log(e);
    }
    this.loader.close();
  }

  onCellEndEdit(event: any) {
    const id = event.args.row.id;
    const appId = event.args.row.appId;
    const menuId = event.args.value.value;
    const menu = {
      Id: id,
      MenuId: menuId,
      AplicacionId: appId
    }
    this.menuService.saveMenuAplicacion(menu);
    MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
    event.args.row.observ = this.menus.get(menuId).Observaciones;
  }

}